"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PropTypes = require("./PropTypes.js");

var _Fieldset = _interopRequireDefault(require("./common/Fieldset.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Regulation = function Regulation(_ref) {
  var regulation = _ref.regulation,
      onChangeRegulation = _ref.onChangeRegulation;
  return /*#__PURE__*/_react["default"].createElement(_Fieldset["default"], {
    value: regulation,
    onChangeValue: onChangeRegulation,
    options: [["UP_DOWN", "Up- or downregulated"], ["UP", "Upregulated only"], ["DOWN", "Downregulated only"]]
  });
};

Regulation.propTypes = {
  regulation: _PropTypes.RegulationType.isRequired,
  onChangeRegulation: _propTypes["default"].func.isRequired
};
var _default = Regulation;
exports["default"] = _default;